export const ONE = '1'
export const TWO = '2'
export const THREE = '3'

export const ALL_LEASE_DEPOSIT_MONTHLY_RENT_MULTIPLES = [
  ONE,
  TWO,
  THREE,
] as const

export type LeaseDepositMonthlyRentMultiple =
  (typeof ALL_LEASE_DEPOSIT_MONTHLY_RENT_MULTIPLES)[number]
